import { render, staticRenderFns } from "./ExtractionTemplatePanel.vue?vue&type=template&id=221899c0&scoped=true&"
import script from "./ExtractionTemplatePanel.vue?vue&type=script&lang=js&"
export * from "./ExtractionTemplatePanel.vue?vue&type=script&lang=js&"
import style0 from "./ExtractionTemplatePanel.vue?vue&type=style&index=0&id=221899c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "221899c0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
